module.exports = __webpack_public_path__ + "static/media/ProximaNova-SemiBold.f14eee64.otf";